import { combineReducers } from "redux";
import user from "./user.reducers";

const userReducers = combineReducers({
  user
});

export default userReducers;
